import React from "react";
import { useTranslation } from "react-i18next";
import { ESTILO_INPUT_GENERICO } from "../utils/const/estilos-const";

export const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

function toPickerHex(value, fallback = "#000000") {
    if (!value) return fallback;
    if (/^#[A-Fa-f0-9]{6}$/i.test(value)) return value.toUpperCase();
    if (/^#[A-Fa-f0-9]{3}$/i.test(value)) {
        const h = value.slice(1);
        return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`.toUpperCase();
    }
    return fallback;
}

export default function ColorPickerComponent({
    id = "color",
    name = "color",
    value = "",
    onChange,
    maxLength = 7,
    fallbackColor = "#000000",
    disabled = false,
    inputClassName = ESTILO_INPUT_GENERICO,
    labelClassName = "block text-md font-medium text-gray-700 mb-2",
    showLabel = true,
    showCharCount = true,
    showValidation = true,
}) {
    const { t } = useTranslation();
    const displayValue = value || fallbackColor;
    const charCount = value?.length ?? 0;
    const isInvalid = Boolean(value) && !HEX_COLOR_REGEX.test(value);

    const handleTextChange = (e) => {
        let next = e.target.value;

        if (next === "") {
            onChange?.("");
            return;
        }

        if (!next.startsWith("#")) {
            next = `#${next}`;
        }

        const hexPart = next.substring(1);
        if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && next.length <= maxLength) {
            onChange?.(next.toUpperCase());
        }
    };

    const handlePickerChange = (e) => {
        onChange?.(e.target.value.toUpperCase());
    };

    return (
        <div>
            {showLabel && (
                <label htmlFor={id} className={labelClassName}>
                    {t("label_color")}
                </label>
            )}
            <div className="flex gap-2 items-center">
                <input
                    id={id}
                    name={name}
                    type="text"
                    value={displayValue}
                    onChange={handleTextChange}
                    className={inputClassName}
                    placeholder="#FF00FF"
                    maxLength={maxLength}
                    disabled={disabled}
                />
                <input
                    type="color"
                    value={toPickerHex(value, fallbackColor)}
                    onChange={handlePickerChange}
                    className="h-10 w-16 cursor-pointer border border-gray-300 rounded"
                    title={t("label_seleccionar_color")}
                    disabled={disabled}
                    aria-label={t("label_seleccionar_color")}
                />
            </div>
            {showCharCount && (
                <p className="text-sm text-gray-500 flex justify-end">
                    {charCount}/{maxLength}
                </p>
            )}
            {showValidation && isInvalid && (
                <p className="text-sm text-red-500 mt-1">
                    {t("alert_formato_color_invalido")}
                </p>
            )}
        </div>
    );
}
